import { emit } from "./eventManager";
import { setTokens } from "../methods/setTokens";
import { getBroadcastChannel } from "./broadcastChannel";
import { initOngoingRefresh, resolveOngoingRefresh } from "../methods/refreshToken";
export function initBroadCastListener() {
  var channel = getBroadcastChannel();
  if (!channel) {
    return;
  }
  channel.onmessage = function (e) {
    var _e$data$payload2;
    switch (e.data.action) {
      case 'logout':
        emit('logout.success');
        break;
      case 'setTokens':
        var _e$data$payload = e.data.payload,
          idToken = _e$data$payload.idToken,
          accessToken = _e$data$payload.accessToken;
        setTokens({
          idToken: idToken,
          accessToken: accessToken,
          callInitSession: false,
          broadcast: false // adding forth false to prevent infinite loop
        });
        break;
      case 'refreshStart':
        initOngoingRefresh();
        break;
      case 'refreshEnd':
        resolveOngoingRefresh((_e$data$payload2 = e.data.payload) === null || _e$data$payload2 === void 0 ? void 0 : _e$data$payload2.tokens);
        break;
    }
  };
}